import { render, staticRenderFns } from "./InclusiveNodeConfig.vue?vue&type=template&id=3bc051d1&scoped=true"
import script from "./InclusiveNodeConfig.vue?vue&type=script&lang=js"
export * from "./InclusiveNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./InclusiveNodeConfig.vue?vue&type=style&index=0&id=3bc051d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc051d1",
  null
  
)

export default component.exports